import { IDataSource } from "Global/Base/DataSources/Interfaces";
import { IFrameWithProfile, IMultiRecordsComponent } from "./FrameInterfaces";
import { IDetailMasterableFrame } from "./IDetailMasterableFrame";

/**
 * Interface pro použiti z BaseFrame
 *
 * @generateInstanceClass
 */
export interface IBaseFrame extends IDetailMasterableFrame, IMultiRecordsComponent, IFrameWithProfile {
    /** Element, ve kterém se nachází obsah framu */
    readonly container: HTMLElement;
    /** Podmínka */
    condition?: string;
    /** Parametry podmínky */
    conditionParamsAttrs?: readonly string[];
    /** Název atributu typu Flags pro obarvování záznamů v seznamu*/
    fontColorAttr?: string;
    /** Čárkou oddělený výčet Flags barev, jen tyto barvy způsobí obarvení celého řádku v seznamu.*/
    fontColorFlags?: string;
    /** Příznak, jestli frame má frame renderovat akce u záznamu*/
    readonly renderStandardRowActions: boolean;

    /** Přidá akce seznamu */
    addCustomActions(): void;
    /**
     * Vytvoří inicializační podmínku pro datasource seznamu
     * Počítá i s formCondition a právy
     */
    createReaderCondition(): Promise<string>;
    /** Určuje, zda je na masterovi vybrán nějaký záznam */
    isMasterRecordSelected(): void;
    /**
     * Vygeneruje nove podminky a parametry pro cteni dat datasourcem
     * @param ds datasource, kteremu se maji nastavit nove podminky
     */
    updateCondition(ds: IDataSource): Promise<void>;
}

export class IBaseFrame {
    private static _properties: (keyof (IBaseFrame))[] = ["container", "renderStandardRowActions"];
    private static _methods: (keyof (IBaseFrame))[] = ["addCustomActions", "createReaderCondition", "isMasterRecordSelected", "updateCondition"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function") && instance instanceof IDetailMasterableFrame
            && instance instanceof IMultiRecordsComponent && instance instanceof IFrameWithProfile && instance instanceof IFrameWithProfile;
    }
}
